import { useMemo } from "react";

/**
 * Search -> status filter, over the full unpaginated collection. Sort stays
 * on the existing useSortableTable mechanism, applied by the caller on top
 * of this hook's output. No template filter (only one template is
 * meaningfully in use today, per product decision).
 */
export function useAlertsFilterSort(collection, { search, statusValues }) {
  return useMemo(() => {
    let rows = collection;

    const query = search.trim().toLowerCase();
    if (query) {
      rows = rows.filter((alert) => alert.name.toLowerCase().includes(query));
    }

    if (statusValues.length) {
      rows = rows.filter((alert) =>
        statusValues.includes(alert.available ? "published" : "unpublished")
      );
    }

    return rows;
  }, [collection, search, statusValues]);
}
